// extracted by mini-css-extract-plugin
export default {"root":"MiniBetaSelectorComplication_root__s01np","selector":"MiniBetaSelectorComplication_selector__dFwrg"};